import feeRules from "../../apis/admin/campaignFeeRules.api";

const BASEURL = process.env.REACT_APP_BACKEND;

const setBaseUrlPrefix = (path) => {
  return BASEURL.concat(path);
};

const apiSponsorPathConstants = {
  organizerSponsor: {
    getAllSponsors: setBaseUrlPrefix("/campaign/:campaignId/sponsors"),
    getSponsorById: setBaseUrlPrefix(`/organizer/sponsors/:id`),
    getUpcomingEvents: setBaseUrlPrefix("/sponsor/event/upcoming"),
    getUpcomingMovies: setBaseUrlPrefix("/sponsor/movie/upcoming"),
  },
  commitments: {
    createCommitment: setBaseUrlPrefix("/organizer/commitments"),
    getCommitmentById: setBaseUrlPrefix(`/organizer/commitments/:id`),
    getCommitments: setBaseUrlPrefix("/organizer/commitments"),
    deleteCommitment: setBaseUrlPrefix(`/organizer/commitments/:id`),
  },
  deliverables: {
    createDeliverables: setBaseUrlPrefix(
      "/organizer/commitments/:id/deliverables"
    ),
    getMyDeliverables: setBaseUrlPrefix(`/organizer/deliverables`),
    getSponsorDeliverablesById: setBaseUrlPrefix(
      "/organizer/commitments/:id/deliverables"
    ),
    updateDeliverablesById: setBaseUrlPrefix(
      "/organizer/commitments/:id/deliverables/:did"
    ),
    editDeliverable: setBaseUrlPrefix(
      "/organizer/commitments/:id/deliverables-edit/:did"
    ),
    reviewDeliverable: setBaseUrlPrefix(
      "/organizer/commitments/:id/deliverables/:did"
    ),
  },
  pitches: {
    createPitch: setBaseUrlPrefix("/organizer/pitches"),
    listMyPitches: setBaseUrlPrefix("/organizer/pitches"),
    getPitchById: setBaseUrlPrefix("/organizer/pitches/:id"),
    editPitch: setBaseUrlPrefix("/organizer/pitches/:id"),
    deletePitch: setBaseUrlPrefix("/organizer/pitches/:id"),
  },
  campaigns: {
    createCampaign: setBaseUrlPrefix("/campaigns"),
    getCampaignById: setBaseUrlPrefix("/campaigns/:campaignId"),
    getAllCampaigns: setBaseUrlPrefix("/campaigns"),
    updateCampaign: setBaseUrlPrefix("/campaigns/:campaignId"),
    deleteCampaign: setBaseUrlPrefix("/campaigns/:campaignId"),
    feeRules:(id) => setBaseUrlPrefix(`/campaigns/${id}/fee-rules`),
    // Campaign Requests
    getAllCampaignRequests: setBaseUrlPrefix("/campaign/applications"),
    getCampaignRequests: setBaseUrlPrefix("/campaigns/:campaignId/requests"),
    getCampaignRequestById: setBaseUrlPrefix(
      "/campaigns/:campaignId/requests/:requestId"
    ),
    AcceptRequest: setBaseUrlPrefix(
      "/campaigns/:campaignId/requests/:requestId/accept"
    ),
    rejectRequest: setBaseUrlPrefix(
      "/campaigns/:campaignId/requests/:requestId/reject"
    ),
    changeRequest: setBaseUrlPrefix(
      "/campaigns/:campaignId/requests/:requestId/change-request"
    ),

    // Campaign Invites
    sendCampaignInvites: setBaseUrlPrefix("/campaigns/:campaignId/invite"),
    getOutgoingInvites: setBaseUrlPrefix("/campaign/outgoing"),
    deleteCampaignInvite: setBaseUrlPrefix(
      "/campaigns/:campaignId/invite/:requestId"
    ),
  },
  payment: {
    getPaymentStatus: (id) =>
      setBaseUrlPrefix(`/organizer/requests/${id}/payments`),
  },
  contract: {
    getContract: (id) => setBaseUrlPrefix(`/contracts/request/${id}`),
  },
  packages: {
    benefitsList: setBaseUrlPrefix("/org/benefits"),
    createCustomPack: setBaseUrlPrefix("/org/:eventId/packs/custom"),
    updateDefaultPack: setBaseUrlPrefix("/org/:eventId/packs/:packId"),
    updateCustomPack: setBaseUrlPrefix("/org/:eventId/packs/:packId/custom"),
    deletePack: setBaseUrlPrefix("/org/:eventId/packs/:packId"),
    previewCalculatePack: setBaseUrlPrefix("/org/packs/preview"),
  },
};

export default apiSponsorPathConstants;
